<script setup lang="ts">
import { reactive, onMounted, ref, watch } from 'vue';
import { getTranslations } from '@/lib/util/i18n';
import debounce from 'lodash/debounce';
import isTouchDevice from '@/lib/util/isTouchDevice';

const emit = defineEmits(['search']);

const state = reactive({ searchTerm: '' });

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'employee-list',
});

const input = ref();

onMounted(() => {
  if (!isTouchDevice()) {
    input.value.focus();
  }
});

const debouncedSearch = debounce(
  () => {
    emit('search', state.searchTerm);
  },
  300,
  { leading: false }
);

watch(
  () => state.searchTerm,
  () => {
    debouncedSearch();
  }
);
</script>

<template>
  <input
    data-test-id="search-input"
    :placeholder="t('search-placeholder')"
    prefix-icon="fal fa-search"
    ref="input"
    class="__search-input"
    :value="state.searchTerm"
    @input="(event) => (state.searchTerm = (event.target as HTMLInputElement).value)"
  />
</template>

<style scoped>
.__search-input {
  display: block;
  font-size: 17px;
  background: url(../assets/images/search.svg) no-repeat scroll 8px 8px,
    var(--co-background-secondary);
  height: 40px;
  border-radius: 8px;
  line-height: 40px;
  border: none;
  padding: 0 15px 0 41px;
  width: 100%;
  max-width: 808px;
  margin: 0 auto;
}
</style>
